import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Slideshow from "../../components/slideshow";
import '../../styles/page.css'

import MegaTeam from '../../images/homepage/slider_mega_team.jpeg'
import PaulClaudia from '../../images/homepage/slider_paul_lauf.jpeg'
import Banner from '../../images/homepage/titel_2025.png'
import Herzlauf from '../../images/homepage/Herzlauf_2025-gr.jpg'
import Blutdruck from '../../images/homepage/Slider_Blutdruck.jpg'
import slider5 from '../../images/homepage/Slider_verspielt_2024.jpg'
import Impfen from '../../images/homepage/Impfen_3_2025.jpg'
import Xund from '../../images/homepage/Slider_Xund.jpeg'
import Influenza from  '../../images/homepage/Slider_Influenza.jpeg'
import Lauf from '../../images/homepage/Laufevent.jpeg'
import sliderA1 from '../../images/homepage/sliderA1.jpeg'
import sliderA2 from '../../images/homepage/sliderA2.jpeg'
import Sliderteamabsage from '../../images/homepage/Slider_terminabsage.jpeg'

import { FaCalendarAlt } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { GrDocumentText } from "react-icons/gr";
import { FaPhoneAlt } from "react-icons/fa";








const HomePageOld = () => {
    return (
        <main> 
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Werte Patienten und Patientinnen! </h1>
                    

                    <p className="page-text">
                        Werte Patientinnen und Patienten! Unser Spektrum reicht von <b> allgemeininternistischen Untersuchungen </b> bis zu <b>kardiologischen Spezialuntersuchungen und Vorsorgeuntersuchungen</b>. 
                    </p>

                    <div className="slideshow-wrapper">
                        <Slideshow images={[MegaTeam, PaulClaudia, Lauf, Xund, Influenza, Herzlauf, Impfen, Blutdruck, slider5]} />
                    </div>
                    
                    <p className="page-text">
                        <br /> <br /> Die Schwerpunkte liegen vor allem im Bereich der nichtinvasiven kardiologischen Diagnostik (<a href="/homepage/#/leistungen">siehe Leistungen</a>).
                        <br /> <br /> Besonderes Augenmerk legen wir auf die Einbeziehung der psychosomatischen Medizin, welche sich mit der Wechselwirkung seelischer (psycho-) Befindlichkeiten auf körperliche (soma-) Zustände beschäftigt.
                        <br /> <br /> Unser Ziel ist eine enge Zusammenarbeit mit den niedergelassenen KollegInnen und den zuständigen Krankenhäusern und Fachabteilungen.
                        <br /> <br /> <span className="red-span">Wir empfehlen das freiwillige Tragen einer FFP2-Maske in der Ordination- vor allem bei viralen oder fieberhaften Infekten oder Krankheitsgefühl. So schützen Sie sich und andere am besten.
                        <br /> <br /> Aus rechtlichen Gründen beantworten wir keine medizinischen Anfragen per Email, bitte lesen Sie dazu auch unsere wichtigen <a href="/homepage/#/hinweise">Hinweise</a> </span>.
                        <br /> <br /> Es werden <span className="red-span"> ausschließlich Rezeptbestellungen per <a href="/homepage/#/kontakt/rezeptbestellung">Formular</a> oder Fax </span>bearbeitet , bitte <b>keine telefonische Bestellung</b> (dadurch sind die Telefonleitungen blockiert).
                        <br /> <br /> Sie können die Medikamente <span className="red-span"> ohne Rezept nach 2 Werktagen </span> direkt in der Apotheke abholen (für den Fall, dass Sie von ELGA abgemeldet sind, müssen Sie das Rezept bitte in der Ordination abholen kommen).
                    </p>
                    <span className="red-btn"> <a href="/homepage/#/kontakt/rezeptbestellung" style={{color:"white", textDecoration:"none"}}> Rezeptbestellung </a>  </span>
                    <p className="page-text">
                        <br /> <br /> Für Terminvereinbarungen bieten wir neben der telefonischen Anmeldung die Möglichkeit, <span className="red-span"> online per Mausklick rasch einen Termin zu fixieren </span>, oder <span className="red-span">per Formular um einen Termin anzufragen</span>.
                    </p>
                    <span className="red-btn"> <a href="/homepage/#/kontakt/terminanfrage" style={{color:"white", textDecoration:"none"}}>Terminanfrage</a>  </span>
                    <span className="red-btn"> <a href="/homepage/#/termine" style={{color:"white", textDecoration:"none"}}> Terminresevierung</a> </span>
                    <p className="page-text">
                        <br /> <br /> Meine Mitarbeiter am Telefon arbeiten mit höchstem Einsatz und sind Ihnen für Ihr Verständnis und Ihre Freundlichkeit dankbar.
                        <br /> <br /> Vielen Dank, liebe Grüße <br /> Claudia Sebald
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}


const ActionCard = ({
    icon,
    title,
    subtitle,
    description,
    buttonText,
    link
  }) => {
    return (
      <div className="action-card">
        <div>
            <div className="action-card-header">
                <div className="action-card-icon">
                {icon}
                </div>

                <div>
                <h3 className="action-card-title">{title}</h3>

                <p className="action-card-subtitle">
                    {subtitle}
                </p>
                </div>
            </div>

            <p className="action-card-description">
                {description}
            </p>
        </div>
            
        <button className="action-card-button" onClick={() => window.location.href = link}>
          {buttonText}
          <span>›</span>
        </button>
      </div>
    );
  };



const HomePage = () => {
    return (
        <main> 
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    {/* Main page content */}
                    <h1> Ordination mit Herz <br /> <span style={{"color":"rgb(172, 17, 17)"}}>für Innere Medizin und Kardiologie  </span> </h1> 
                    
                    <div class="termin-absage-info-box">
                        <h2> Wichtiger Hinweis zu Terminabsagen </h2>
                        <p>
                        Sollten Sie einen vereinbarten Termin nicht wahrnehmen können, ersuchen wir Sie, diesen <strong> mindestens 24 Stunden vorher abzusagen. </strong>
                        Bei Nichterscheinen ohne rechtzeitige Absage müssen wir Ihnen <strong> € 100,- Ausfallhonorar </strong> in Rechnung stellen.
                        Wir danken für Ihr Verständnis und dafür, dass Sie damit anderen Patientinnen und Patienten die Möglichkeit geben, den Termin zu nutzen.
                        </p>
                    </div>
        

                    <div className="action-cards-grid">
                        <ActionCard
                            icon={<FaCalendarAlt />}
                            title="Termin buchen"
                            subtitle="Für neue Patienten"
                            description="Wartezeiten auf Ersttermine können derzeit länger sein. Telefonisch geht es aktuell nicht schneller als online."
                            buttonText="Termin"
                            link="/homepage/#/termine"
                        />

                        <ActionCard
                            icon={<FiRefreshCw />}
                            title="Kontaktformular"
                            subtitle="Für allgemeine organisatorische Anliegen"
                            description="Für organisatorische Fragen, Befunde, Überweisungen oder sonstige Anliegen. Wir melden uns zeitnah bei Ihnen."
                            buttonText="Kontaktformular"
                            link="/homepage/#/kontakt/terminanfrage"
                        />

                        <ActionCard
                            icon={<GrDocumentText />}
                            title="Rezept bestellen"
                            subtitle="Für bestehende Patienten"
                            description="Bekannte Dauermedikation einfach online anfragen."
                            buttonText="Rezept"
                            link="/homepage/#/kontakt/rezeptbestellung"
                        />

                        <ActionCard
                            icon={<FaPhoneAlt />}
                            title="Rückruf anfordern"
                            subtitle="Für sonstige Anliegen"
                            description="Wenn Ihr Anliegen nicht online gelöst werden kann, rufen wir Sie gerne zurück. Meist am Nachmittag."
                            buttonText="Anruf"
                            link="/homepage/#/kontakt/terminanfrage"
                        />
                    </div>

                    <div class="contact-notice">
                        <h2>
                            Für weitere Anliegen nutzen sie bitte unser
                            <a href="/homepage/#/kontakt/terminanfrage"> Kontaktformular</a>
                        </h2>

                        <p>
                            <strong>Bitte beachten Sie: </strong>
                            Aus rechtlichen Gründen beantworten wir keine medizinischen Anfragen
                            per elektronischen Schriftverkehr. Für medizinische Fragen oder
                            Befundbesprechungen vereinbaren Sie bitte einen Termin.
                        </p>
                    </div>

                    <div className="slideshow-wrapper">
                        <Slideshow images={[Sliderteamabsage, sliderA1, sliderA2, MegaTeam, PaulClaudia, Lauf, Xund, Influenza, Herzlauf, Impfen, Blutdruck, slider5]} />
                    </div>
                    
                    
                    <section class="practice-section">
                        <h1>Unsere Ordination</h1>

                        <p>
                            Werte Patientinnen und Patienten,
                        </p>

                        <p>
                            in unserer Ordination bieten wir
                            <strong> allgemeininternistische und kardiologische Untersuchungen </strong>
                            sowie Vorsorgeuntersuchungen an. Hier finden sie
                            <a href="/homepage//#/leistungen"> alle Leistungen &gt;</a>
                        </p>

                        <p>
                            Der Schwerpunkt liegt auf der nichtinvasiven kardiologischen Diagnostik.
                            Besonderes Augenmerk legen wir auf die Einbeziehung der psychosomatischen
                            Medizin. Unser Ziel ist eine persönliche Betreuung und eine gute
                            Zusammenarbeit mit den weiterbehandelnden Krankenhäusern, Kolleginnen
                            und Kollegen sowie Fachabteilungen.
                        </p>

                        <h2>Ihr Erstbesuch</h2>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Für Ihren ersten Termin bringen Sie bitte nach Möglichkeit relevante
                                Vorbefunde sowie eine aktuelle Medikamentenliste mit.
                            </p>
                        </div>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Da wir uns für jeden Termin ausreichend Zeit nehmen und laufend auch
                                Ersttermine einplanen, kann es leider zu längeren Wartezeiten kommen.
                                Wir bemühen uns, Termine so verlässlich und fair wie möglich zu vergeben.
                            </p>
                        </div>

                        <div class="info-item">
                            <span class="plus">+</span>
                            <p>
                                Wir empfehlen das freiwillige Tragen einer FFP2-Maske, insbesondere
                                bei viralen oder fieberhaften Infekten oder bei Krankheitsgefühl.
                                So schützen Sie sich und andere Patientinnen und Patienten.
                            </p>
                        </div>

                        <h2>Telefon &amp; Rückruf</h2>

                        <p>
                            Bei hoher Nachfrage kann es telefonisch zu längeren Wartezeiten kommen.
                            Termine sind telefonisch nicht schneller verfügbar als online. Wenn Ihr
                            Anliegen nicht online gelöst werden kann, fordern Sie bitte einen Rückruf an.
                        </p>

                        <p>
                            Weitere Kontaktmöglichkeiten finden Sie unter
                            <a href="/homepage/#/kontakt"> Kontakt &gt;</a>
                        </p>
                    </section>

                </div>

                 {/* Main page content end */}

            </section>
            <Footer />
        </main>
    )
}

export default HomePage;